<template>
  <div :class="$style.record">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>提现记录</p>
    </header>
    <ul>
      <li v-for="(item, index) in recordList" :key="index">
        <div>
          <!-- 目前只有微信，后续若有其他提现方式需要服务端加字段 -->
          <p :class="$style.where">提现到{{ handleType(item.type) }}</p>
          <p :class="$style.date">{{item.created_at}}</p>
        </div>
        <div>
          <div :class="$style.money"><span>{{item.money}}</span>元</div>
          <p :class="`${$style.status} ${$style['type-' + item.status]}`"><span></span>{{getStatus(item.status)}}</p>
        </div>
      </li>
    </ul>
    <div v-if="!recordList.length" :class="$style.unRecord">暂无提现记录</div>
  </div>
</template>

<script>
import { sort_ASCII } from '@/libs/utils'
import { mapState } from 'vuex'
import { withDrawRecord, withDrawRecordV2 } from '@/api/activity';

export default {
  name: '',
  data () {
    return {
      recordList: []
    };
  },
  mounted() {
    this.getRecord()
  },
  computed: {
    ...mapState({
      user_id: state => state.user.user_id,
      receive_info: (state) => state.redEnvelope.receive_info,
      role: (state) => state.redEnvelope.role,
    })
  },
  methods: {
    back() {
      this.$emit('setPage', 'wallet');
    },
    async getRecord() {
      let r = null;
      if (this.receive_info.version == 2) {
        r = await withDrawRecordV2({
          user_id: this.user_id,
          role_id: this.role.role_id
        })
        this.recordList = r.content.record_list || [];
      } else {
        r = await withDrawRecord({
          user_id: this.user_id
        })
        this.recordList = r.content || [];
      }
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return '待审核'
        case 1:
        case 4:
          return '领取失败'
        case 2: 
          return '发放中'
        case 3:
          return '领取成功'
        case 5:
          return '道具下发中'
        default: 
          return '待审核'
      }
    },
    handleType(type) {
      if (type == 1) {
        return '微信'
      } else if (type == 2) {
        return '支付宝'
      } else if (type == 3) {
        return '游戏直充'
      }
    }
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.record {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  overflow: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 30px;
    padding: 12px 0 24px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/condition_back.png');
    background-size: 100% 100%;
    color: #FFFFFF;
    > .back {
      position: absolute;
      left: 0;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px { top: 0; left: 0 };
    }
  }
  > ul {
    padding: 0 12px;
    > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .where {
        color: #424242;
        font-size: $font-nm;
        margin-bottom: 5px;
      }
      .date {
        color: #707070;
        font-size: $font-sm;
      }
      .money {
        font-size: $font-nm;
        text-align: right;
        > span {
          font-size: 21px;
          line-height: 15px;
          display: inline-block;
          vertical-align: text-top;
          margin-right: 1.5px;
        }
      }
      .status {
        position: relative;
        font-size: 9px;
        text-align: right;
        margin-top: 3px;
        &.type-0, &.type-2, &.type-4 {
          color: #FF5B58;
        }
        &.type-1 {
          color: #FF5B58;
          > span {
            background: #FF5B58;
          }
        }
        &.type-3 {
          color: #1AAA32;
           > span {
            background: #1AAA32;
          }
        }
        > span {
          display: inline-block;
          width: 2.5px;
          height: 2.5px;
          vertical-align: middle;
          margin-right: 2.5px;
          border-radius: 50%;
          background: #FF5B58;
        }
      }
    }
  }
  .unRecord {
    margin-top: 150px;
    font-size: 14px;
    text-align: center;
    color: #a8a8a8;
  }
}
</style>  